
const arrayDays = ['Domingo','Lunes','Martes','Miércoles','Jueves','Viernes','Sabado'];
const arrayMonths = ['Enero','Febrero','Marzo','Abril','Mayo','Junio','Julio','Agosto','Septiembre','Octubre','Noviembre','Diciembre'];    

/* NORMAL */

 // var entrega_mañana = {
 //                       "0":{"first_day":2, "last_day":3}, // domingo antes de las 7   - recibe entre martes y miercoles
 //                       "1":{"first_day":1, "last_day":2}, // lunes antes de las 7     - recibe entre martes y miercoles
 //                       "2":{"first_day":1, "last_day":2}, // martes antes de las 7    - recibe entre miercoles y jueves
 //                       "3":{"first_day":1, "last_day":2}, // miercoles antes de las 7 - recibe entre jueves y viernes 
 //                       "4":{"first_day":1, "last_day":4}, // jueves antes de las 7    - recibe entre viernes y lunes 
 //                       "5":{"first_day":4, "last_day":5}, // viernes antes de las 7   - recibe entre martes y miercoles
 //                       "6":{"first_day":3, "last_day":4}, // sabado antes de las 7    - recibe entre martes y miercoles
 //                      };  
 // var entrega_tarde = {
 //                       "0":{"first_day":2, "last_day":3}, // domingo despues de las 7   - recibe entre martes y miercoles
 //                       "1":{"first_day":2, "last_day":3}, // lunes despues de las 7     - recibe entre miercoles y jueves
 //                       "2":{"first_day":2, "last_day":3}, // martes despues de las 7    - recibe entre jueves y viernes 
 //                       "3":{"first_day":2, "last_day":5}, // miercoles despues de las 7 - recibe entre viernes y lunes 
 //                       "4":{"first_day":5, "last_day":6}, // jueves despues de las 7    - recibe entre martes y  miercoles
 //                       "5":{"first_day":4, "last_day":5}, // viernes despues de las 7   - recibe entre martes y  miercoles
 //                       "6":{"first_day":3, "last_day":4}, // sabado despues de las 7    - recibe entre martes y  miercoles
 //                      };

/* ESPECIAL FERIADO */

 var entrega_mañana = {
                       "0":{"first_day":4, "last_day":5}, // domingo antes de las 7   - recibe entre martes y miercoles
                       "1":{"first_day":3, "last_day":4}, // lunes antes de las 7     - recibe entre martes y miercoles
                       "2":{"first_day":8, "last_day":9}, // martes antes de las 7    - recibe entre miercoles y jueves
                       "3":{"first_day":8, "last_day":9}, // miercoles antes de las 7 - recibe entre jueves y viernes 
                       "4":{"first_day":7, "last_day":8}, // jueves antes de las 7    - recibe entre viernes y lunes 
                       "5":{"first_day":6, "last_day":7}, // viernes antes de las 7   - recibe entre martes y miercoles
                       "6":{"first_day":5, "last_day":6}, // sabado antes de las 7    - recibe entre martes y miercoles
                      };  
 var entrega_tarde = {
                       "0":{"first_day":4, "last_day":5}, // domingo despues de las 7   - recibe entre martes y miercoles
                       "1":{"first_day":8, "last_day":9}, // lunes despues de las 7     - recibe entre miercoles y jueves
                       "2":{"first_day":8, "last_day":9}, // martes despues de las 7    - recibe entre jueves y viernes 
                       "3":{"first_day":8, "last_day":9}, // miercoles despues de las 7 - recibe entre viernes y lunes 
                       "4":{"first_day":7, "last_day":8}, // jueves despues de las 7    - recibe entre martes y  miercoles
                       "5":{"first_day":6, "last_day":7}, // viernes despues de las 7   - recibe entre martes y  miercoles
                       "6":{"first_day":5, "last_day":6}, // sabado despues de las 7    - recibe entre martes y  miercoles
                      };

const fecha_actual = new Date();

function calculateDate(day,count){
  day.setDate(new Date().getDate()+count);
  return day;
}
function dayPosition(date){
  return date.getDay(); 
}
function dayPositionName(date){
  return arrayDays[date.getDay()]; 
}  
function getDateNumber(date){
  return date.getDate(); 
}
function getDateMonth(date){
  return arrayMonths[date.getMonth()];
}    
function rangeDayFirst(nro){
  let calcDate = calculateDate(new Date(), nro);
  return "entre "+dayPositionName(calcDate)+" "+getDateNumber(calcDate)+" de "+ getDateMonth(calcDate)+" y ";
}
function rangeDayLast(nro){
  let calcDate = calculateDate(new Date(), nro);
  return dayPositionName(calcDate)+" "+getDateNumber(calcDate)+" de "+ getDateMonth(calcDate);
}

// ------ DAY TEST  ------
// const today = new Date("2024-08-16");
// today.setHours(7);

// ------ DAY REAL ------
const today = new Date();

// ------ HOLIDAYS ------
const startHoliday = new Date("2024-08-14");
startHoliday.setHours(0); 
const endHoliday = new Date("2024-08-19");
endHoliday.setHours(0); 

function actualizar_fecha_envio(){  

  // VACACIONES AGOSTO 24
  const year = today.getFullYear();
  const month = today.getMonth() + 1;  
  const day = today.getDate();
  const hours = today.getHours();
  const isBefore7AM = hours < 7;
  const isAfter7AM = hours >= 7;
  
  const is12 = year === 2024 && month === 8 && day === 12;
  const is13 = year === 2024 && month === 8 && day === 13;

  if (is12 ){
    if (isBefore7AM){
      document.getElementById("eta-message").textContent = "entre Martes 13 y Miércoles 14 de Agosto.";
    }
    if (isAfter7AM){
      document.getElementById("eta-message").textContent = "entre Miércoles 14 y Viernes 16 de Agosto.";
    }
  }
  else if (is13 ){
    if (isBefore7AM){
      document.getElementById("eta-message").textContent = "entre Miércoles 14 y Viernes 16 de Agosto.";
    }
    if (isAfter7AM){
      document.getElementById("eta-message").textContent = "entre Martes 20 y Miércoles 21 de Agosto.";
    }
  }  
  else if (today >= startHoliday && today <= endHoliday) {
      document.getElementById("eta-message").textContent = "entre Martes 20 y Miércoles 21 de Agosto.";
  } 
  // END VACACIONES AGOSTO 24
  else {
  
    let fecha_actual = new Date();
    let fecha_envio = new Date();    
    let fecha_actual_dia = fecha_actual.getDay();  
    let fecha_actual_hora = fecha_actual.getHours();  
    let dayItem_first;
    let dayItem_last;    
    if (fecha_actual_hora < 7){
        dayItem_first = entrega_mañana[fecha_actual_dia].first_day;       
        dayItem_last  = entrega_mañana[fecha_actual_dia].last_day;        
    } else {        
        dayItem_first = entrega_tarde[fecha_actual_dia].first_day;           
        dayItem_last  = entrega_tarde[fecha_actual_dia].last_day;                           
    }  
    let etaMessageElement = document.getElementById("eta-message")
    if (etaMessageElement){
      etaMessageElement.textContent = rangeDayFirst(dayItem_first)+rangeDayLast(dayItem_last);
    }
    
  }
}   
setInterval(actualizar_fecha_envio, 2000);   

